/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface OfficeSettingsAdminService {
  /** @summary List Office Settings */
  listAdminOfficeSettings: {
    /** @summary List Office Settings */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListAdminOfficeSettingsParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListAdminOfficeSettingsSchema,
        options: {
          parameters: ListAdminOfficeSettingsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListAdminOfficeSettingsData, ListAdminOfficeSettingsError>>
    ): Promise<RequestFnResponse<ListAdminOfficeSettingsData, ListAdminOfficeSettingsError>>;
    /** @summary List Office Settings */
    getQueryKey(
      parameters: DeepReadonly<ListAdminOfficeSettingsParameters> | void
    ): ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officeSettingsAdminService.listAdminOfficeSettings.useQuery()
     * ```
     */
    useQuery<TData = ListAdminOfficeSettingsData>(
      parameters:
        | ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListAdminOfficeSettingsData,
          ListAdminOfficeSettingsError,
          TData,
          ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListAdminOfficeSettingsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.officeSettingsAdminService.listAdminOfficeSettings.useQuery()
     * ```
     */
    useQuery<TData = ListAdminOfficeSettingsData>(
      parameters:
        | ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListAdminOfficeSettingsData,
          ListAdminOfficeSettingsError,
          TData,
          ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListAdminOfficeSettingsError>>;
    /** @summary List Office Settings */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListAdminOfficeSettingsParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeSettingsAdminService.listAdminOfficeSettings.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAdminOfficeSettingsParameters,
      TQueryFnData = ListAdminOfficeSettingsData,
      TData = OperationInfiniteData<TQueryFnData, ListAdminOfficeSettingsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAdminOfficeSettingsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListAdminOfficeSettingsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeSettingsAdminService.listAdminOfficeSettings.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListAdminOfficeSettingsParameters,
      TQueryFnData = ListAdminOfficeSettingsData,
      TData = OperationInfiniteData<TQueryFnData, ListAdminOfficeSettingsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListAdminOfficeSettingsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAdminOfficeSettingsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListAdminOfficeSettingsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listAdminOfficeSettingsTotal = qraft.officeSettingsAdminService.listAdminOfficeSettings.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
        | QueryFiltersByQueryKey<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listAdminOfficeSettingsResults = qraft.officeSettingsAdminService.listAdminOfficeSettings.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAdminOfficeSettingsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listAdminOfficeSettingsCombinedResults = qraft.officeSettingsAdminService.listAdminOfficeSettings.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAdminOfficeSettingsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListAdminOfficeSettingsSchema,
          ListAdminOfficeSettingsParameters,
          ListAdminOfficeSettingsData,
          ListAdminOfficeSettingsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListAdminOfficeSettingsData, ListAdminOfficeSettingsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListAdminOfficeSettingsData, ListAdminOfficeSettingsError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.officeSettingsAdminService.listAdminOfficeSettings.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListAdminOfficeSettingsData>(
      parameters:
        | ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListAdminOfficeSettingsData,
          ListAdminOfficeSettingsError,
          TData,
          ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListAdminOfficeSettingsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeSettingsAdminService.listAdminOfficeSettings.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListAdminOfficeSettingsParameters, TData = ListAdminOfficeSettingsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListAdminOfficeSettingsData,
          ListAdminOfficeSettingsError,
          OperationInfiniteData<TData, ListAdminOfficeSettingsParameters>,
          ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListAdminOfficeSettingsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListAdminOfficeSettingsParameters>,
      OperationError<ListAdminOfficeSettingsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Office Settings
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listAdminOfficeSettingsData = qraft.officeSettingsAdminService.listAdminOfficeSettings.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAdminOfficeSettingsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listAdminOfficeSettingsCombinedData = qraft.officeSettingsAdminService.listAdminOfficeSettings.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listAdminOfficeSettingsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListAdminOfficeSettingsSchema,
          ListAdminOfficeSettingsParameters,
          ListAdminOfficeSettingsData,
          ListAdminOfficeSettingsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListAdminOfficeSettingsData, ListAdminOfficeSettingsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<ListAdminOfficeSettingsData, ListAdminOfficeSettingsError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Office Settings */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAdminOfficeSettingsSchema,
        ListAdminOfficeSettingsData,
        ListAdminOfficeSettingsParameters,
        ListAdminOfficeSettingsError
      > | void
    ): Promise<ListAdminOfficeSettingsData>;
    /** @summary List Office Settings */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListAdminOfficeSettingsSchema,
        ListAdminOfficeSettingsData,
        ListAdminOfficeSettingsParameters,
        ListAdminOfficeSettingsError
      > | void
    ): Promise<void>;
    /** @summary List Office Settings */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListAdminOfficeSettingsSchema,
        ListAdminOfficeSettingsData,
        ListAdminOfficeSettingsParameters,
        ListAdminOfficeSettingsError
      > | void
    ): Promise<ListAdminOfficeSettingsData>;
    /** @summary List Office Settings */
    fetchInfiniteQuery<TPageParam extends ListAdminOfficeSettingsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAdminOfficeSettingsSchema,
        ListAdminOfficeSettingsData,
        ListAdminOfficeSettingsParameters,
        DeepReadonly<TPageParam>,
        ListAdminOfficeSettingsError
      > | void
    ): Promise<OperationInfiniteData<ListAdminOfficeSettingsData, ListAdminOfficeSettingsParameters>>;
    /** @summary List Office Settings */
    prefetchInfiniteQuery<TPageParam extends ListAdminOfficeSettingsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListAdminOfficeSettingsSchema,
        ListAdminOfficeSettingsData,
        ListAdminOfficeSettingsParameters,
        DeepReadonly<TPageParam>,
        ListAdminOfficeSettingsError
      > | void
    ): Promise<void>;
    /** @summary List Office Settings */
    ensureInfiniteQueryData<TPageParam extends ListAdminOfficeSettingsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListAdminOfficeSettingsSchema,
        ListAdminOfficeSettingsData,
        ListAdminOfficeSettingsParameters,
        DeepReadonly<TPageParam>,
        ListAdminOfficeSettingsError
      > | void
    ): Promise<OperationInfiniteData<ListAdminOfficeSettingsData, ListAdminOfficeSettingsParameters>>;
    /** @summary List Office Settings */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void)
    ): ListAdminOfficeSettingsData | undefined;
    /** @summary List Office Settings */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void)
    ): OperationInfiniteData<ListAdminOfficeSettingsData, ListAdminOfficeSettingsParameters> | undefined;
    /** @summary List Office Settings */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
        | QueryFiltersByQueryKey<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListAdminOfficeSettingsSchema,
              ListAdminOfficeSettingsParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<ListAdminOfficeSettingsData, ListAdminOfficeSettingsParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>,
            data: ListAdminOfficeSettingsData | undefined,
          ]
        >;
    /** @summary List Office Settings */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | void)
    ): QueryState<ListAdminOfficeSettingsData, ListAdminOfficeSettingsError> | undefined;
    /** @summary List Office Settings */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListAdminOfficeSettingsParameters>
        | ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<ListAdminOfficeSettingsData, ListAdminOfficeSettingsParameters>,
          ListAdminOfficeSettingsError
        >
      | undefined;
    /** @summary List Office Settings */
    setQueryData(
      parameters:
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | undefined)
        | ServiceOperationQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>,
      updater: Updater<
        NoInfer<ListAdminOfficeSettingsData> | undefined,
        NoInfer<DeepReadonly<ListAdminOfficeSettingsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListAdminOfficeSettingsData | undefined;
    /** @summary List Office Settings */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListAdminOfficeSettingsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListAdminOfficeSettingsSchema, ListAdminOfficeSettingsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListAdminOfficeSettingsData, ListAdminOfficeSettingsParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<ListAdminOfficeSettingsData, ListAdminOfficeSettingsParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListAdminOfficeSettingsData, ListAdminOfficeSettingsParameters> | undefined;
    /** @summary List Office Settings */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
        | QueryFiltersByQueryKey<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >,
      updater: Updater<
        NoInfer<ListAdminOfficeSettingsData> | undefined,
        NoInfer<ListAdminOfficeSettingsData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListAdminOfficeSettingsData | undefined>;
    /** @summary List Office Settings */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListAdminOfficeSettingsSchema,
        ListAdminOfficeSettingsData,
        TInfinite,
        ListAdminOfficeSettingsParameters,
        ListAdminOfficeSettingsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Office Settings */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
        | QueryFiltersByQueryKey<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Office Settings */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
        | QueryFiltersByQueryKey<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Office Settings */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
        | QueryFiltersByQueryKey<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
    ): void;
    /** @summary List Office Settings */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
        | QueryFiltersByQueryKey<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Office Settings */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
        | QueryFiltersByQueryKey<
            ListAdminOfficeSettingsSchema,
            ListAdminOfficeSettingsData,
            TInfinite,
            ListAdminOfficeSettingsParameters,
            ListAdminOfficeSettingsError
          >
    ): number;
    schema: ListAdminOfficeSettingsSchema;
    types: {
      parameters: ListAdminOfficeSettingsParameters;
      data: ListAdminOfficeSettingsData;
      error: ListAdminOfficeSettingsError;
    };
  };
  /**
   * @summary Update Office Settings
   * @description Partial delta: only the fields the caller actually sent are written, in both families.
   *
   * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
   * whole-form save reverts flips made out of band between load and save (VA-351).
   */
  updateAdminOfficeSettings: {
    /**
     * @summary Update Office Settings
     * @description Partial delta: only the fields the caller actually sent are written, in both families.
     *
     * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
     * whole-form save reverts flips made out of band between load and save (VA-351).
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateAdminOfficeSettingsBody,
        UpdateAdminOfficeSettingsParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateAdminOfficeSettingsSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateAdminOfficeSettingsBody,
          UpdateAdminOfficeSettingsParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateAdminOfficeSettingsData, UpdateAdminOfficeSettingsError>>
    ): Promise<RequestFnResponse<UpdateAdminOfficeSettingsData, UpdateAdminOfficeSettingsError>>;
    /**
     * @summary Update Office Settings
     * @description Partial delta: only the fields the caller actually sent are written, in both families.
     *
     * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
     * whole-form save reverts flips made out of band between load and save (VA-351).
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateAdminOfficeSettingsParameters> | void
    ): ServiceOperationMutationKey<UpdateAdminOfficeSettingsSchema, UpdateAdminOfficeSettingsParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Office Settings
     * @description Partial delta: only the fields the caller actually sent are written, in both families.
     *
     * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
     * whole-form save reverts flips made out of band between load and save (VA-351).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officeSettingsAdminService.updateAdminOfficeSettings.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officeSettingsAdminService.updateAdminOfficeSettings.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateAdminOfficeSettingsBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateAdminOfficeSettingsParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateAdminOfficeSettingsSchema,
        UpdateAdminOfficeSettingsData,
        UpdateAdminOfficeSettingsParameters,
        TVariables,
        OperationError<UpdateAdminOfficeSettingsError>,
        TContext
      >
    ): UseMutationResult<
      UpdateAdminOfficeSettingsData,
      OperationError<UpdateAdminOfficeSettingsError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Office Settings
     * @description Partial delta: only the fields the caller actually sent are written, in both families.
     *
     * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
     * whole-form save reverts flips made out of band between load and save (VA-351).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.officeSettingsAdminService.updateAdminOfficeSettings.useMutation({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.officeSettingsAdminService.updateAdminOfficeSettings.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateAdminOfficeSettingsBody, UpdateAdminOfficeSettingsParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateAdminOfficeSettingsSchema,
        UpdateAdminOfficeSettingsData,
        UpdateAdminOfficeSettingsParameters,
        TVariables,
        OperationError<UpdateAdminOfficeSettingsError>,
        TContext
      >
    ): UseMutationResult<
      UpdateAdminOfficeSettingsData,
      OperationError<UpdateAdminOfficeSettingsError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Office Settings
     * @description Partial delta: only the fields the caller actually sent are written, in both families.
     *
     * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
     * whole-form save reverts flips made out of band between load and save (VA-351).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateAdminOfficeSettingsTotal = qraft.officeSettingsAdminService.updateAdminOfficeSettings.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateAdminOfficeSettingsTotal = qraft.officeSettingsAdminService.updateAdminOfficeSettings.useIsMutating({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateAdminOfficeSettingsBody,
            UpdateAdminOfficeSettingsData,
            UpdateAdminOfficeSettingsParameters,
            OperationError<UpdateAdminOfficeSettingsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAdminOfficeSettingsSchema,
            UpdateAdminOfficeSettingsBody,
            UpdateAdminOfficeSettingsData,
            UpdateAdminOfficeSettingsParameters,
            OperationError<UpdateAdminOfficeSettingsError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Office Settings
     * @description Partial delta: only the fields the caller actually sent are written, in both families.
     *
     * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
     * whole-form save reverts flips made out of band between load and save (VA-351).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateAdminOfficeSettingsPendingMutationVariables = qraft.officeSettingsAdminService.updateAdminOfficeSettings.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateAdminOfficeSettingsMutationData = qraft.officeSettingsAdminService.updateAdminOfficeSettings.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateAdminOfficeSettingsData,
        OperationError<UpdateAdminOfficeSettingsError>,
        MutationVariables<UpdateAdminOfficeSettingsBody, UpdateAdminOfficeSettingsParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateAdminOfficeSettingsBody,
            UpdateAdminOfficeSettingsData,
            UpdateAdminOfficeSettingsParameters,
            OperationError<UpdateAdminOfficeSettingsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAdminOfficeSettingsSchema,
            UpdateAdminOfficeSettingsBody,
            UpdateAdminOfficeSettingsData,
            UpdateAdminOfficeSettingsParameters,
            OperationError<UpdateAdminOfficeSettingsError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateAdminOfficeSettingsData,
          OperationError<UpdateAdminOfficeSettingsError>,
          MutationVariables<UpdateAdminOfficeSettingsBody, UpdateAdminOfficeSettingsParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update Office Settings
     * @description Partial delta: only the fields the caller actually sent are written, in both families.
     *
     * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
     * whole-form save reverts flips made out of band between load and save (VA-351).
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateAdminOfficeSettingsBody,
            UpdateAdminOfficeSettingsData,
            UpdateAdminOfficeSettingsParameters,
            OperationError<UpdateAdminOfficeSettingsError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateAdminOfficeSettingsSchema,
            UpdateAdminOfficeSettingsBody,
            UpdateAdminOfficeSettingsData,
            UpdateAdminOfficeSettingsParameters,
            OperationError<UpdateAdminOfficeSettingsError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Office Settings
     * @description Partial delta: only the fields the caller actually sent are written, in both families.
     *
     * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
     * whole-form save reverts flips made out of band between load and save (VA-351).
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.officeSettingsAdminService.updateAdminOfficeSettings.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.officeSettingsAdminService.updateAdminOfficeSettings.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateAdminOfficeSettingsBody,
              UpdateAdminOfficeSettingsData,
              UpdateAdminOfficeSettingsParameters,
              OperationError<UpdateAdminOfficeSettingsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateAdminOfficeSettingsSchema,
              UpdateAdminOfficeSettingsBody,
              UpdateAdminOfficeSettingsData,
              UpdateAdminOfficeSettingsParameters,
              OperationError<UpdateAdminOfficeSettingsError>,
              TContext
            >
      ):
        | Mutation<
            UpdateAdminOfficeSettingsData,
            UpdateAdminOfficeSettingsError,
            MutationVariables<UpdateAdminOfficeSettingsBody, UpdateAdminOfficeSettingsParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateAdminOfficeSettingsBody,
              UpdateAdminOfficeSettingsData,
              UpdateAdminOfficeSettingsParameters,
              OperationError<UpdateAdminOfficeSettingsError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateAdminOfficeSettingsSchema,
              UpdateAdminOfficeSettingsBody,
              UpdateAdminOfficeSettingsData,
              UpdateAdminOfficeSettingsParameters,
              OperationError<UpdateAdminOfficeSettingsError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateAdminOfficeSettingsData,
          UpdateAdminOfficeSettingsError,
          MutationVariables<UpdateAdminOfficeSettingsBody, UpdateAdminOfficeSettingsParameters>,
          TContext
        >
      >;
    };
    schema: UpdateAdminOfficeSettingsSchema;
    types: {
      parameters: UpdateAdminOfficeSettingsParameters;
      data: UpdateAdminOfficeSettingsData;
      error: UpdateAdminOfficeSettingsError;
      body: UpdateAdminOfficeSettingsBody;
    };
  };
}
/** @summary List Office Settings */
export const listAdminOfficeSettings = {
  schema: {
    method: 'get',
    url: '/admin/office_settings/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListAdminOfficeSettingsSchema;
  [QraftServiceOperationsToken]: OfficeSettingsAdminService['listAdminOfficeSettings'];
};
/**
 * @summary Update Office Settings
 * @description Partial delta: only the fields the caller actually sent are written, in both families.
 *
 * The matrix flips one cell at a time and must never rewrite a flag it did not touch — a
 * whole-form save reverts flips made out of band between load and save (VA-351).
 */
export const updateAdminOfficeSettings = {
  schema: {
    method: 'patch',
    url: '/admin/office_settings/{office_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateAdminOfficeSettingsSchema;
  [QraftServiceOperationsToken]: OfficeSettingsAdminService['updateAdminOfficeSettings'];
};
export const officeSettingsAdminService = {
  listAdminOfficeSettings,
  updateAdminOfficeSettings,
} as const;
type ListAdminOfficeSettingsSchema = {
  method: 'get';
  url: '/admin/office_settings/';
  security: ['HTTPBearer'];
};
type ListAdminOfficeSettingsParameters = undefined;
type ListAdminOfficeSettingsData =
  paths['/admin/office_settings/']['get']['responses']['200']['content']['application/json'];
type ListAdminOfficeSettingsError = unknown;
type UpdateAdminOfficeSettingsSchema = {
  method: 'patch';
  url: '/admin/office_settings/{office_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateAdminOfficeSettingsParameters = paths['/admin/office_settings/{office_id}']['patch']['parameters'];
type UpdateAdminOfficeSettingsData =
  paths['/admin/office_settings/{office_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateAdminOfficeSettingsError =
  paths['/admin/office_settings/{office_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateAdminOfficeSettingsBody =
  paths['/admin/office_settings/{office_id}']['patch']['requestBody']['content']['application/json'];
